import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[libAutoTab]',
})
export class NextInputDirective {
  @Input() libAutoTab;
  constructor() {}
  @HostListener('input', ['$event.target']) onInput(input) {
    const length = input.value.length;
    let maxLength = parseInt(input.attributes.maxlength.value);

    if (length >= maxLength && this.libAutoTab) {
      const field = document.getElementById(this.libAutoTab);
      if (field) {
        field.focus();
      }
    }
  }
}
